import { Button } from "./styles";
import { useRouter } from "next/router";
import { useTranslation } from "@/lib/translations";

type Props = {
  url: any;
};

const DownloadButton: React.FC<Props> = (props) => {
  const { url } = props;
  const { locale = "it" } = useRouter();

  const t = {
    downloadPdf: useTranslation("productListing.downloadPdf", locale) || "",
  };

  if (!url || typeof url !== "string") return null;
  return <Button href={url + "?dl="}>{t.downloadPdf}</Button>;
};

export default DownloadButton;
